import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
import { LOCATIONS, OPENING_HOURS, PHONE } from '../data/locations';
const QUICK_LINKS = [{
  to: '/',
  label: 'Home'
}, {
  to: '/therapists',
  label: 'Our Ladies'
}, {
  to: '/locations',
  label: 'Locations'
}, {
  to: '/services',
  label: 'Services & Pricing'
}, {
  to: '/book',
  label: 'Book a session'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Footer() {
  return <footer className="glow-warm w-full border-t border-lotus-500/25 bg-ink-900" data-id="element-25" data-mp="37fth3568s26">
      <div className="mx-auto grid w-full max-w-7xl gap-10 px-5 py-16 sm:px-8 md:grid-cols-3" data-id="element-26" data-mp="3lf57orxofrmx">
        <div data-id="element-27" data-mp="3qcnlavmn2v19">
          <Logo showTagline data-id="element-28" data-mp="3qcdp2qb03rn4" />
          <p className="mt-6 max-w-xs text-sm font-light leading-relaxed text-neutral-400" data-id="element-29" data-mp="3qfjighqnxfon">
            Professional massage &amp; relaxation services across Queensland. Services for men only,
            ages 18+.
          </p>
          <p className="mt-4 flex items-center gap-2 text-sm text-neutral-300" data-id="element-30" data-mp="3l9adtjp9964y">
            <PhoneIcon className="h-4 w-4 text-lotus-400" aria-hidden="true" data-id="element-31" data-mp="3lbdd6ucasbmc" />
            <a href={`tel:${PHONE.replace(/\s/g, '')}`} className="hover:text-lotus-300" data-id="element-32" data-mp="3gca859wbi5ed">
              {PHONE}
            </a>
          </p>
          <p className="mt-2 flex items-center gap-2 text-sm text-neutral-300" data-id="element-33" data-mp="3q8wphopfqebn">
            <ClockIcon className="h-4 w-4 text-orchid-400" aria-hidden="true" data-id="element-34" data-mp="3qazqf3s4lrv5" />
            {OPENING_HOURS}
          </p>
        </div>

        <div data-id="element-35" data-mp="34patc8mu2kd">
          <h2 className="text-[11px] font-medium uppercase tracking-[0.3em] text-lotus-400" data-id="element-36" data-mp="32vybgbc8o4g">
            Quick links
          </h2>
          <ul className="mt-6 space-y-3 text-sm font-light text-neutral-400" data-id="element-37" data-mp="huwicwx3q16a">
            {QUICK_LINKS.map(link => <li key={link.to} data-id="element-38" data-mp="qthyymj0j64f">
                <Link to={link.to} className="hover:text-lotus-300" data-id="element-39" data-mp="qsqadvnu28nn">
                  {link.label}
                </Link>
              </li>)}
          </ul>
        </div>

        <div data-id="element-40" data-mp="tvmqpiubmimf">
          <h2 className="text-[11px] font-medium uppercase tracking-[0.3em] text-orchid-400" data-id="element-41" data-mp="tvw8wk94jlhk">
            Our locations
          </h2>
          <ul className="mt-6 space-y-3 text-sm font-light text-neutral-400" data-id="element-42" data-mp="yuh6ebwzrr2b">
            {LOCATIONS.map(loc => <li key={loc.slug} className="flex gap-2" data-id="element-43" data-mp="13rfy6nt6nlxc">
                <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-orchid-400" aria-hidden="true" data-id="element-44" data-mp="18ksmewty9qpk" />
                <Link to={`/locations/${loc.slug}`} className="hover:text-orchid-300" data-id="element-45" data-mp="1hkp94sws4fhz">
                  <span className="text-neutral-200" data-id="element-46" data-mp="1hmifs87e6zpz">{loc.suburb}</span> — {loc.name}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>

      <div className="border-t border-white/[0.07]" data-id="element-47" data-mp="1ri3k4czxoc2w">
        <p className="mx-auto w-full max-w-7xl px-5 py-6 text-xs text-neutral-500 sm:px-8" data-id="element-48" data-mp="3obwzv73o0ms8">
          © {new Date().getFullYear()} Me Time. All rights reserved.
        </p>
      </div>
    </footer>;
}